export const parseTimecodeToSeconds = (input = '') => {
    if (typeof input !== 'string') return null;
    const trimmed = input.trim();
    if (!trimmed) return null;
    const parts = trimmed.split(':');
    if (parts.length !== 2) return null;
    const [mPart, sPart] = parts;
    if (sPart.length < 1 || sPart.length > 2) return null;
    const minutes = Number(mPart);
    const seconds = Number(sPart);
    if (!Number.isInteger(minutes) || minutes < 0) return null;
    if (!Number.isInteger(seconds) || seconds < 0 || seconds > 59) return null;
    return Math.max(0, minutes * 60 + seconds);
};

export const formatSecondsToTimecode = (seconds = 0) => {
    const safe = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
    const mins = Math.floor(safe / 60);
    const secs = safe % 60;
    return `${mins}:${String(secs).padStart(2, '0')}`;
};

const timecodeUtils = { parseTimecodeToSeconds, formatSecondsToTimecode };

export default timecodeUtils;
